export function fn () {
  console.log('lib2 fn');
}